export const en_translation = {
  zuora: {
    title: "Payment Method",
    "CC-label":
      "Make secure payment using your preferred payment method. Please enter your payment information to proceed.",
    "ACH-label":
      "Pay securely using your checking account.  Please enter your bank account information to proceed.",
    button: "Continue to Review",
    // tslint:disable-next-line:max-line-length
    error:
      "We're unable to process your payment details at this moment. It seems there might be an error with the information entered. Please double check your details and try again. Please note that some VISA and Mastercard Gift Cards cannot be used to make recurring payments.",
    tmna: {
      "consent-cc-one":
        "Checking this box authorizes the scheduled charges to the credit card provided",
      "consent-cc-two": "Terms of Use",
      "consent-cc-three": " including the refund policy as described in the ",
      "consent-ach-one":
        "Checking this box authorizes the scheduled charges to the checking account provided ​",
      "consent-ach-two": "Terms of Use",
      "consent-ach-three":
        " including the refund policy as described in the ​​",
    },
    tmca_t: {
      "consent-cc-one":
        "At Toyota, we prioritise the safety of your data. Please review our ​",
      "consent-cc-two": "privacy policy",
      "consent-cc-three":
        " to learn more about how we handle your payment information.​​",
      "consent-ach-one":
        "At Toyota, we prioritise the safety of your data. Please review our ​",
      "consent-ach-two": "privacy policy",
      "consent-ach-three":
        " to learn more about how we handle your payment information.​​",
    },
    tmca_l: {
      "consent-cc-one":
        "At Lexus, we prioritise the safety of your data. Please review our",
      "consent-cc-two": "privacy policy",
      "consent-cc-three":
        " to learn more about how we handle your payment information.",
      "consent-ach-one":
        "At Lexus, we prioritise the safety of your data. Please review our",
      "consent-ach-two": "privacy policy",
      "consent-ach-three":
        " to learn more about how we handle your payment information.",
    },
    tdpr: {
      "consent-cc-one":
        "By checking this box, I hereby authorize the scheduled charges to be made to the credit card I have provided, as described here and in the ",
      "consent-cc-two": "Connected Services Terms of Use",
      "consent-cc-three": ", including the refund policy.",
      "consent-ach-one":
        "By checking this box, I hereby authorize the scheduled charges to be made to the bank account provided, as described here and in the ",
      "consent-ach-two": "Connected Services Terms of Use​​",
      "consent-ach-three": ", including the refund policy.​​",
    },
    tci: {
      "consent-cc-one":
        "By checking this box, I hereby authorize the current and future monthly charges to be made to the credit card I have provided, as described here and in the ",
      "consent-cc-two": "Connected Services Terms of Use",
      "consent-cc-three": ", including the refund policy.",
      "consent-ach-one": "N/A",
      "consent-ach-two": "",
      "consent-ach-three": "",
    },
    "default-payment": "Default Payment Method",
  },
};
